var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaderVisible)?_c('div',{staticClass:"app-data-loader"},[_c('img',{attrs:{"src":"img/loaders/Rolling-1.2s-200px.svg","alt":"Loading data... Please wait."}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }